<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="signup">
                <template slot="header">
                  <h4 class="card-title text-center">Request Password Link</h4>
                </template>
                <ValidationObserver ref="forgetPasswordForm" v-slot="{ handleSubmit }">
                  <form @submit="handleSubmit(forgetPassword)">
                    <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                      <fg-input
                        :error="errors[0]"
                        v-model="form.email"
                        addon-left-icon="nc-icon nc-email-85"
                        placeholder="Email address"
                      ></fg-input>
                    </ValidationProvider>
                    <div class="text-center">
                      Go back to
                      <router-link :to="{name: 'Login'}">Login</router-link>
                    </div>
                    <p-button
                      native-type="submit"
                      slot="footer"
                      type="warning"
                      round
                      block
                      class="mb-3"
                      @click.native.prevent="handleSubmit(forgetPassword)"
                    >Request Password Link</p-button>
                  </form>
                </ValidationObserver>
              </card>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/background-2.jpg)"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Checkbox, Button } from "src/components/UIComponents";
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";
import { Message } from "element-ui";

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },
    forgetPassword() {
      this.$store
        .dispatch("user/requestPasswordChange", this.form)
        .then(response => {
           this.showAlertMessage(response.data.message, "success");
        })
        .catch(error => {
           this.showAlertMessage(error.response.data.message, "error");
        });
    }
  },
  data() {
    return {
      form: {
        email: ""
      }
    };
  },
  beforeDestroy() {
    this.closeMenu();
  }
};
</script>
<style>
</style>
